export { default } from './ExpandedFiltersOverlay';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/ExpandedFiltersOverlay/index.js